import type { Edge } from '@shared/hydraulic'
import type { Side } from './orthogonal-router'

/** Parse the side ('right'|'left'|'bottom'|'top') out of a handle string like 'right-src'. */
export function sideFromHandle(handle: string | undefined): Side | null {
  if (!handle) return null
  const [side] = handle.split('-')
  return side === 'right' || side === 'left' || side === 'bottom' || side === 'top' ? side : null
}

/** Sides already occupied by pipes at `nodeId` (for router collision avoidance). */
export function collectUsedSides(edges: Edge[], nodeId: string, excludeEdgeId?: string): Set<Side> {
  const taken = new Set<Side>()
  for (const edge of edges) {
    if (edge.id === excludeEdgeId) continue
    const d = edge.diagram
    if (edge.connection.source_id === nodeId) {
      const s = sideFromHandle(d.sourceHandle)
      if (s) taken.add(s)
    }
    if (edge.connection.target_id === nodeId) {
      const s = sideFromHandle(d.targetHandle)
      if (s) taken.add(s)
    }
  }
  return taken
}
